import React from 'react';

// Shared segmented tab control — one tab look across the whole app.
export const TabBar = ({ tabs, active, onChange, testIdPrefix = 'tab', className = '' }) => (
    <div className={`inline-flex items-center gap-1 p-1 rounded-xl bg-gray-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 shadow-inner ${className}`} data-testid={`${testIdPrefix}-bar`}>
        {tabs.map(t => {
            const isActive = active === t.id;
            return (
                <button key={t.id} onClick={() => onChange(t.id)} data-testid={t.testId || `${testIdPrefix}-${t.id}`}
                    className={`relative flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors ${isActive
                        ? 'bg-white dark:bg-slate-900 text-ica-navy dark:text-ica-light-gold shadow-sm ring-1 ring-ica-gold/60'
                        : 'text-gray-500 dark:text-slate-400 hover:text-ica-navy dark:hover:text-slate-200 hover:bg-white/60 dark:hover:bg-slate-700/40'}`}>
                    {t.icon && <t.icon className={`w-4 h-4 ${isActive ? 'text-ica-gold' : ''}`} />}
                    {t.label}
                    {t.count !== undefined && t.count !== null && (
                        <span className={`min-w-[1.4rem] text-center text-xs font-bold px-1.5 py-0.5 rounded-md ${isActive ? 'bg-ica-navy text-white dark:bg-ica-gold dark:text-slate-900' : 'bg-gray-200 text-gray-500 dark:bg-slate-700 dark:text-slate-300'}`}>{t.count}</span>
                    )}
                    {isActive && <span className="absolute -bottom-px left-4 right-4 h-0.5 rounded-full bg-ica-gold" />}
                </button>
            );
        })}
    </div>
);
